// extracted by mini-css-extract-plugin
export default {"newContactContainer":"style_newContactContainer__czmtH","newHeader":"style_newHeader__BnB6u","newContent":"style_newContent__mSdzD","buttonsWrapper":"style_buttonsWrapper__e4jXr"};